import { render, staticRenderFns } from "./BolsasEdescontos.vue?vue&type=template&id=1d366a15&scoped=true&lang=pug&"
import script from "./BolsasEdescontos.vue?vue&type=script&lang=js&"
export * from "./BolsasEdescontos.vue?vue&type=script&lang=js&"
import style0 from "./BolsasEdescontos.styl?vue&type=style&index=0&id=1d366a15&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d366a15",
  null
  
)

export default component.exports